import { XIcon } from 'fasoo-ui-component-next';
import { useTranslation } from 'react-i18next';
import { findApprovalTypeIcon } from 'src/pages/users/approval/pending/ApprovalPendingList';
import { ShowLineContent } from '.';
import './ApprovalTypeIconArea.scss';
import classNames from 'classnames';

export interface ApprovalTypeIconAreaProps {
  type: string;
  status: string;
  onClose: (open: boolean) => void;
}

const pendingReqList = ['APPLY', 'PROGRESS'];
const completeReqList = ['APPROVAL', 'REJECT', 'CANCEL'];

export const ApprovalTypeIconArea: React.FC<ApprovalTypeIconAreaProps> = ({
  type,
  status,
  onClose,
}) => {
  const { t } = useTranslation(['menu', 'userApproval']);
  const handleCloseDetail = (): void => {
    onClose(false);
  };
  return (
    <>
      <div className="header-area">
        <div className="header-side-area-left">dummy </div>
        <div className="header-title-area">
          {pendingReqList.includes(status)
            ? t('userApproval:approvalDetail.pendingRequest')
            : t('userApproval:approvalDetail.completeRequest')}
        </div>
        {/* <ShowLineContent classes="detail-title" title={'결재 대기건 상세 내용'} /> */}
        <div onClick={handleCloseDetail} className="header-side-area">
          <XIcon />
        </div>
      </div>

      <div className="detail-approvaltype-icon-area">
        <div className="approvaltype-icon-area-contents">
          {findApprovalTypeIcon(type)}
          <ShowLineContent
            classes={classNames('approvaltype-icon-content')}
            title={t(`userApproval:approvalType.${type}`)}
          />
        </div>
      </div>
    </>
  );
};
